import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
  selector: 'fgbcl-language-button-select',
  templateUrl: './language-button-select.component.html',
  styleUrl: './language-button-select.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class LanguageButtonSelectComponent {
  @Input() visibleLanguagesByLcid: string[] = [];
  @Input() version: number = 1;
}
